import { viction as viemViction } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const viction = {
  displayName: 'Viction',
  runtime: 'evm',
  viemChain: viemViction,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'tomochain' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
